
import { Component, Vue } from "vue-property-decorator";
import JielongIntro from "@/components/JielongIntro/index.vue";
import { JielongIntroCardDetail } from "@/api/jielong";

@Component({
  components: { JielongIntro },
})
export default class JielongIntroDemo extends Vue {
  cards: JielongIntroCardDetail[] = [];

  get prettyCards (): string {
    return JSON.stringify(this.cards, null, 2);
  }
}
